import { apiStatus, howToBuyProductActionType } from '../../../actionTypes';

const initialState = {
  referralUrl: '',
  data: {},
};

const howToBuyProduct = (state = initialState, action) => {
  switch (action.type) {
    case howToBuyProductActionType.REDIRECT_HOW_TO_BUY_PRODUCT:
      const { referralUrl } = action.payload || {};
      return {
        ...state,
        referralUrl,
      };
    case howToBuyProductActionType.GET_HOW_TO_BUY_PRODUCT_REQUEST:
      const { handle, productId } = action.payload || {};
      return {
        ...state,
        data: {
          ...state.data,
          [`${handle}-${productId}`]: {
            apiState: apiStatus.INITIATED,
            productId,
          },
        },
      };
    case howToBuyProductActionType.GET_HOW_TO_BUY_PRODUCT_SUCCESS: {
      const { handle, productId, ...howToBuyData } = action.payload || {};
      return {
        ...state,
        data: {
          ...state.data,
          [`${handle}-${productId}`]: {
            apiState: apiStatus.SUCCESS,
            productId,
            ...howToBuyData,
          },
        },
      };
    }
    case howToBuyProductActionType.GET_HOW_TO_BUY_PRODUCT_ERROR: {
      const { handle, productId } = action.payload || {};
      return {
        ...state,
        data: {
          ...state.data,
          [`${handle}-${productId}`]: {
            apiState: apiStatus.ERROR,
          },
        },
      };
    }
    default:
      return state;
  }
};

export default howToBuyProduct;



// WEBPACK FOOTER //
// ./reducer/buyWithInstacred/howToBuyProduct/index.js